var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderEFTG',{ref:"headerEFTG",attrs:{"showAuth":false}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"text-center mb-4"},[_vm._v("404")]),_c('h3',{staticClass:"test-center"},[_vm._v("Page not found")])])
}]

export { render, staticRenderFns }